// Added useRef
import { useCallback, useEffect, useRef, useState } from "react";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { handlePixelInit } from "../services/tags.js";

import "../index.css";
import {
  eventClick,
  eventWithFormInfo,
  fieldErrorEvent,
  formAbandonEvent,
  formIntermediateEventOTP,
  formStarts,
  formSubmissionFailEvent,
  formSubmitEvent,
  submitErrorEvent,
} from "../services/adobeDataLayer.js";

// lsq start

import queryString from "query-string";
import { useCookies } from "react-cookie";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../App.css";
import {
  callLSQLapp,
  encryptBody,
  getFirstNameLastName,
  getLsqLeadBody,
} from "../services/lsq.js";
import { notifySuccess, notifyWarn } from "../services/Toastifyfn";
import {
  formatAndValidateE164,
  hashValue,
  setValuesInLocalStorange,
} from "../services/utils.js";
// lsq end

function Form({ customADL, setCustomADL }) {
  let navigate = useNavigate();
  const [name, setname] = useState("");
  // Added Last name
  const [lastname, setlastname] = useState("");

  const [pan, setpan] = useState("");
  const [pincode, setpincode] = useState("");
  const [mobile, setmobile] = useState("");
  const [branch, setbranch] = useState("");

  const [otp, setotp] = useState("");
  const [checkbox, setcheckbox] = useState("");
  const [showPan, setShowPan] = useState("");

  const [newMargin, setNewMargin] = useState(false);
  let isValid = 0;
  // SETINPUTS
  const [inputs, setInputs] = useState({
    User_Agent: navigator.userAgent,
    ApiProductName: "3in1Account",
    CampaignId: "832997",
    source: "Landing Page",
    CompleteUrl: window.location.href,
  });

  const [checked, setChecked] = useState(false);
  const [formStarted, setFormStarted] = useState(false);

  // otpstatus 0 - blank otp field
  // otptatus 1 - resend button enabled on otp field
  // otpstatus 2 - timer enabled on otp field
  const [otpstatus, setOtpstatus] = useState(0);

  // Date Chages Start here
  const [date, setDate] = useState(false);
  const [month, setMonth] = useState(false);
  const dayRef = useRef(null);
  const monthRef = useRef(null);
  const yearRef = useRef(null);
  const [dob, setdob] = useState("");
  // End Date Chages

  // lsq integration start
  const [otpsent, setOtpsent] = useState(false);
  const [fbp, setFbp] = useState("");
  const [fbc, setFbc] = useState("");
  const [cookies, setCookie] = useCookies();
  const [disableBtn, setDistablebtn] = useState(false);
  const [token, setToken] = useState("");
  const [otpdisableBtn, setOtpBtn] = useState(false);
  const [btnDisable, setBtnDisable] = useState(true);
  const [disableApplyBtn, setApplyBtnDisable] = useState(false);
  const [validpincode, setValidincode] = useState(false);
  const [options, setOptions] = useState([
    { SOL_ID: "00", Branch_Name: "Select Branch" },
  ]);
  const [solId, setSolid] = useState("");

  const [timerDisplay, setTimerDisplay] = useState("none");
  const [otpBtnText, setOtpBtnText] = useState("Resend");
  const [resendBtnDisplay, hideDisplayBtn] = useState("initial");
  const [timer, setTimer] = useState(0);
  const [otpDisabled, setOtpDisabled] = useState(false);
  const lastAccessedField = useRef("");

  const timeOutCallback = useCallback(
    () => setTimer((currTimer) => currTimer - 1),
    []
  );
  useEffect(() => {
    if (inputs.mobile?.length === 10 && otpsent) {
      timer > 0 && setTimeout(timeOutCallback, 1000);
    }
  }, [timer, timeOutCallback, inputs.mobile, otpsent]);

  // set Fbp, Fbc, UTM parameters values
  // useEffect(() => {
  //   let retryCount = 0; // Initialize retry counter
  //   const maxRetries = 5; // Maximum retries
  //   const retryInterval = 4000; // Interval between retries in ms

  //   const captureCookies = () => {
  //     setFbp(cookies["_fbp"] || "");
  //     setFbc(cookies["_fbc"] || "");

  //     // Check if retries are needed
  //     if ((!cookies["_fbp"] || !cookies["_fbc"]) && retryCount < maxRetries) {
  //       console.log(retryCount)

  //       retryCount++;
  //       setTimeout(captureCookies, retryInterval); // Retry after the interval
  //     }
  //   };

  //   captureCookies(); // Start capturing cookies on mount
  // }, []);

  useEffect(() => {
    let retryCount = 0; // Initialize retry counter
    const maxRetries = 5; // Maximum retries
    const retryInterval = 4000; // Interval between retries in ms

    const getCookieValue = (cookieName) => {
      return document.cookie
        .split("; ")
        .find((row) => row.startsWith(cookieName))
        ?.split("=")[1];
    };

    const captureCookies = () => {
      const fbpValue = getCookieValue("_fbp") || "";
      const fbcValue = getCookieValue("_fbc") || "";

      setFbp(fbpValue);
      setFbc(fbcValue);

      // Check if retries are needed
      if ((!fbpValue || !fbcValue) && retryCount < maxRetries) {
        console.log(retryCount);
        retryCount++;
        setTimeout(captureCookies, retryInterval); // Retry after the interval
      }
    };

    captureCookies(); // Start capturing cookies on mount
  }, []);

  useEffect(() => {
    // console.log(customADL,"custo,ADL")
    if (customADL.formStarts && customADL.cta) {
      if (customADL.formStarts < customADL.cta) {
        // console.log("formAbandon")
        formAbandonEvent(lastAccessedField.current);
        setCustomADL({ ...customADL, formStarts: "" });
      }
    }
  }, [customADL]);

  // Logger
  useEffect(() => {
    // console.log("lead payload", inputs)
  }, [inputs]);

  const handlePanView = (e) => {
    e.preventDefault();
    setShowPan(!showPan);
  };

  const handleRightCLickTC = (e) => {
    e.preventDefault();
    eventClick("terms and conditions", "link", "form");
  };

  const mainFun = async (mobile) => {
    if ("OTPCredential" in window) {
      const input = document.querySelector(
        'input[autoComplete="one-time-code"]'
      );
      if (!input) return;
      const ac = new AbortController();
      try {
        const otp = await navigator.credentials.get({
          otp: {
            transport: ["sms"],
          },
          signal: ac.signal,
        });
        input.value = otp.code;
        setInputs((inputs) => ({ ...inputs, otp: otp.code }));
        setTimeout(verifyOTPText(mobile, otp.code), 5000);
      } catch (err) {
        console.error("Error occurred:", err);
      }
    }
  };

  // sendOTPText otp
  const sendOTPText = async (mobileNumber, option) => {
    // let mobileNumber = e.target.value;
    if (
      !mobileNumber ||
      mobileNumber.length !== 10 ||
      !mobileNumber.match(/^[6-9]\d{9}$/)
    ) {
      return;
    }
    if (mobileNumber.length === 10 && mobileNumber.match(/^[6-9]\d{9}$/)) {
      let payload = { mobile: mobileNumber, messageType: "otpGeneral" };
      let param = { otp: "send", productType: "BG", autoReadOtp: "yes" };
      const otpResponse = await callLSQLapp(payload, "OTP", param);
      if (otpResponse.data.message.response.sent) {
        setOtpsent(true);
        notifySuccess("OTP has been sent to your mobile number.");
        let otpType = option === "resend" ? "resend" : "send";
        if (option !== "resend") formIntermediateEventOTP(otpType);
        if (option === "resend")
          eventWithFormInfo("resend", "button", "form", "", inputs);

        // setDistablebtn(true);
        setTimerDisplay("inline");
        setTimer(30);
        await mainFun(mobileNumber);
      } else if (
        otpResponse.data.message.response === "MAX OTP Limit reached"
      ) {
        window.alert("OTP Limit reached, try again after 5 minutes");
        window.location.reload();
      } else {
        notifyWarn("Please Resend OTP.");
        setDistablebtn(true);
        setTimerDisplay("inline");
        setTimer(30);
        setOtpsent(false);
      }

      // setMobileval(mobileNumber);
    }
  };

  // verifyOTP
  const verifyOTPText = async (mobileNum, otpValue) => {
    let payload = { mobile: mobileNum, otp: otpValue };
    let param = { otp: "verify", productType: "BG" };
    const otpVerifyResponse = await callLSQLapp(payload, "OTP", param);
    if (
      otpVerifyResponse.data.message === "Failure Occured, please check logs"
    ) {
      notifyWarn("Invalid OTP");
      // fieldErrorEvent("invalid otp", "otp");

      let myInputs = { ...inputs };
      // console.log("inputs are", myInputs);
      myInputs.otp = "";
      setInputs(myInputs);
      // setResendBtn(true);
      return;
    }
    const tokenValue =
      otpVerifyResponse.data.message.response.dataSent.UniqueID;

    setToken(tokenValue);
    inputs.otp = otpValue;
    // setResendBtn(false);
    setDistablebtn(true);
    setOtpBtn(true);
    setBtnDisable(false);
    setTimer(0);
    setOtpDisabled(true);
    hideDisplayBtn("initial");
    setOtpBtnText("Verified");
    formIntermediateEventOTP("verified");

    notifySuccess("OTP Verified Successfully.");
  };

  /**
   * this fn will take pincode and set options for branches to display on UI
   * @param {*} pincode
   */
  async function handleChangePIN(pincode) {
    let PIN = pincode.target.value;
    setInputs((inputs) => ({ ...inputs, ["pincode"]: PIN }));
    if (PIN.length === 6) {
      // console.log("PIN", PIN);
      let payload = { pincode: PIN };
      let param = { type: "SavingsAccountPincode" };
      let response = await callLSQLapp(payload, "MAVIS", param);
      // console.log("response", response);
      if (response.data.message.Count === 0) {
        // console.log("Please enter valid pincode");
        setpincode("Please enter valid pincode");
        setInputs((inputs) => ({
          ...inputs,
          branch: "",
          City: "",
          State: "",
        }));
        setSolid("");
        setValidincode(false);
        setNewMargin(true);
      } else {
        setpincode("");
        setValidincode(true);
        setOptions(response.data.message.Data);
        // set solid and branch
        setInputs((inputs) => ({
          ...inputs,
          branch: response.data.message.Data[0].Branch_Name,
          City: response.data.message.Data[0].City,
          State: response.data.message.Data[0].State,
        }));
        setSolid(response.data.message.Data[0].SOL_ID);
      }
    }
  }

  /**
   * this useEffect is being used for sending and verifying otp against the mobile number
   */
  useEffect(() => {
    let mobileVal = inputs["mobile"];
    let OTP = inputs["otp"] ? inputs["otp"] : "";
    if (mobileVal !== undefined) {
      if (OTP.length === 6 && mobileVal.length === 10 && token === "") {
        // console.log("verifying num", { OTP, mobileVal });
        verifyOTPText(mobileVal, OTP);
      }
    }
  }, [token, inputs["otp"], inputs["mobile"]]);

  // lsq integration end

  const handleChange = (event) => {
    setCustomADL({ ...customADL, formStarts: Date.now() });
    if (!formStarted) {
      formStarts();
      setCustomADL({ ...customADL, formStarts: Date.now() });
      setFormStarted(true);
    }

    var name = event.target.name;
    var value = event.target.value;

    if (name === "pan") {
      value = value.replace(/\s\s+/g, " ");
      value = value.toUpperCase();
      value = value.replace(/[^a-zA-Z0-9]/g, "");

      if (value.length <= 5 && /[^a-zA-Z]/.test(value)) {
        value = value.slice(0, -1);
      }

      if (
        value.length > 5 &&
        value.length <= 9 &&
        /^[^0-9]+$/.test(value.slice(5, 9))
      ) {
        value = value.slice(0, -1);
      }

      if (value.length === 10 && /^[^a-zA-Z]/.test(value.slice(-1))) {
        value = value.slice(0, -1);
      }
    }

    // we are setting solID here against the branchName
    if (name === "branch") {
      const selectedOptionSolid =
        event.target.options[event.target.selectedIndex].getAttribute("solid");
      setSolid(selectedOptionSolid.toString());
    }

    // console.log("name & value", { name, value });

    // dob Changes Start

    // Date validate date and change focus
    if (name === "dob") {
      if (value.length === 2 && value === "00") {
        value = "";
        setDate(value);
      }
      if (value.length === 1 && value >= 1 && value <= 3) {
        setDate(value);
      } else if (value.length === 1 && value >= 4 && value <= 9) {
        setDate("0" + value);
        monthRef.current.focus();
      } else if (value.length === 2 && value >= 10 && value <= 31) {
        setDate(value);
        monthRef.current.focus();
      } else if (value >= 32) {
        setDate(value.slice(0, 1));
      } else {
        setDate(value);
        // console.log(date)
      }
    }

    // // Month validate date and change focus
    if (name === "dob_month") {
      if (value.length === 1 && value === 1) {
        setMonth(value);
      } else if (value.length === 1 && value >= 2 && value <= 9) {
        if (value === 2 && date >= 30) {
          setDate("");
          dayRef.current.focus();
        } else {
          yearRef.current.focus();
        }
        setMonth("0" + value);
      } else if (value.length === 2 && value >= 10 && value <= 12) {
        setMonth(value);
        yearRef.current.focus();
      } else if (value >= 13) {
        setMonth(value.slice(0, 1));
      } else {
        setMonth(value);
        // console.log(month)
      }
    }

    // // Year validate date and change focus
    if (name === "dob_month") {
      if (date >= 1 && date <= 3 && date.length === 1) {
        setDate("0" + date);
      }
      if (value.length === 2 && value === "00") {
        value = "";
        setMonth(value);
      }
      if (value.length === 1 && value === 1) {
        setMonth(value);
      } else if (value.length === 1 && value >= 2 && value <= 9) {
        setMonth("0" + value);
        yearRef.current.focus();
      } else if (value.length === 2 && value >= 10 && value <= 12) {
        setMonth(value);
        yearRef.current.focus();
      } else if (value >= 13) {
        setMonth(value.slice(0, 1));
      } else {
        setMonth(value);
      }
    }

    if (name === "dob_year") {
      if (value.length === 1) {
        if (value !== "1" && value !== "2") {
          value = "";
        }
      }

      if (value.length === 2) {
        if (value !== "19" && value !== "20") {
          value = value.slice(0, -1);
        }
      }
      // MAX AGE
      let yearStart = new Date().getFullYear() - 70;
      var year = new Date().getFullYear();

      if (value.length === 4 && value < yearStart) {
        value = value.slice(0, -1);
      }

      if (value.length === 4 && value > year) {
        value = value.slice(0, -1);
      }

      if (date >= 1 && date <= 3 && date.length === 1) {
        setDate("0" + date);
      }

      if (month >= 1 && month <= 9 && month.length === 1) {
        setMonth("0" + month);
      }
    }
    // dob Changes End

    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const handleBlur = (event) => {
    const name = event.target.name;
    lastAccessedField.current = name;
    const mobile_reg = /^[6-9]{1}[0-9]{9}$/;
    const regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;

    const name_reg = /^[a-zA-Z ]*$/;

    if (name === "name") {
      if (
        inputs.name === "" ||
        inputs.name === undefined ||
        inputs.name.trim().length <= 2
      ) {
        setname("Please enter your full name.");
        fieldErrorEvent("Please enter your full name.", "name");
        isValid++;
      } else {
        if (!inputs.name.match(name_reg)) {
          setname("Please enter valid full name.");
          fieldErrorEvent("Please enter valid full name.", "name");

          isValid++;
        } else {
          setname("");
        }
      }
    }

    // Last name validaton
    // if (name === "lastname") {
    //   if (inputs.lastname === "" || inputs.lastname === undefined) {
    //     setlastname("Please enter your last name.");
    //     setNewMargin(true);
    //     isValid++;
    //   } else {
    //     if (inputs.lastname.trim().length < 1) {
    //       setlastname("Please enter valid last name.");
    //       setNewMargin(true);
    //       isValid++;
    //     } else if (!inputs.lastname.match(lastname_reg)) {
    //       setlastname("Please enter valid last name.");
    //       setNewMargin(true);
    //       isValid++;
    //     } else {
    //       setlastname("");
    //     }
    //   }
    // }

    if (name === "mobile") {
      if (!inputs.mobile) {
        setmobile("Please enter your mobile number.");
        fieldErrorEvent("Please enter your mobile number.", "mobile");
        setNewMargin(true);
        isValid++;
      } else {
        if (!inputs.mobile.match(mobile_reg)) {
          setmobile("Please enter valid mobile number.");
          fieldErrorEvent("Please enter valid mobile number.", "mobile");

          setNewMargin(true);
          isValid++;
        } else {
          setmobile("");
        }
      }
    }

    if (name === "pan") {
      if (!inputs.pan) {
        setpan("Please enter your pan number.");
        fieldErrorEvent("Please enter your pan number.", "pan");
        setNewMargin(true);
        isValid++;
      } else {
        if (!inputs.pan.match(regpan)) {
          setpan("Please enter valid pan number.");
          fieldErrorEvent("Please enter valid pan number.", "pan");
          setNewMargin(true);
          isValid++;
        } else {
          setpan("");
        }
      }
    }

    if (name === "pincode") {
      var pincode_reg = /^[1-9][0-9]{5}$/;
      if (!inputs.pincode) {
        setpincode("Please enter valid pincode.");
        fieldErrorEvent("Please enter valid pincode.", "pincode");
        setNewMargin(true);
        isValid++;
      } else {
        // console.log("validpincode", validpincode);
        if (!inputs.pincode.match(pincode_reg) || !validpincode) {
          setpincode("Please enter valid pincode.");
          fieldErrorEvent("Please enter valid pincode.", "pincode");
          setNewMargin(true);
          isValid++;
        } else {
          // console.log("clearing this");
          setpincode("");
        }
      }
    }

    if (name === "otp") {
      var otp_reg = /^[0-9]{6}$/;
      if (!inputs.otp) {
        setotp("Please enter valid otp.");
        fieldErrorEvent("Please enter valid otp.", "otp");
        setNewMargin(true);
        isValid++;
      } else {
        if (!inputs.otp.match(otp_reg)) {
          setotp("Please enter valid otp number.");
          fieldErrorEvent("Please enter valid otp number.", "otp");
          setNewMargin(true);
          isValid++;
        } else {
          setotp("");
        }
      }
    }

    if (name === "branch") {
      if (!inputs.branch) {
        setbranch("Please select branch.");
        fieldErrorEvent("Please select branch.", "branch");
        setNewMargin(true);
        isValid++;
      }

      if (validpincode && inputs.branch) {
        setbranch("");
      }
    }

    // dob Changes Start

    if (name === "dob" || name === "dob_month" || name === "dob_year") {
      var year = new Date().getFullYear();
      var yearStart = new Date().getFullYear() - 110;
      var dob_error = false;
      if (
        name === "dob" &&
        inputs.dob !== "undefined" &&
        !(inputs.dob >= 1 && inputs.dob <= 31)
      ) {
        isValid++;
        dob_error = true;
        setdob("Please enter valid Date Of Birth.");
        fieldErrorEvent("Please enter valid Date Of Birth.", "dob");
      } else {
        dob_error = false;

        setdob("");
      }

      if (name === "dob_month" && !dob_error) {
        if (
          typeof inputs.dob_month !== "undefined" &&
          !(inputs.dob_month >= 1 && inputs.dob_month <= 12)
        ) {
          isValid++;
          dob_error = true;
          setdob("Please enter valid Date Of Birth.");
          fieldErrorEvent("Please enter valid Date Of Birth.", "dob");
        } else {
          dob_error = false;
          setdob("");
        }
      }

      if (name === "dob_year" && !dob_error) {
        if (!inputs.dob_year) {
          isValid++;
          setdob("Please enter valid Date Of Birth.");
          fieldErrorEvent("Please enter valid Date Of Birth.", "dob");
        } else if (
          (typeof inputs.dob_year !== "undefined" &&
            inputs.dob_year < yearStart) ||
          inputs.dob_year >= year
        ) {
          isValid++;
          setdob("Please enter valid Date Of Birth.");
          fieldErrorEvent("Please enter valid Date Of Birth.", "dob");
        } else {
          setdob("");
        }
      }
    }
    // dob Changes End
  };

  const errorRef = useRef({});
  const handleSubmit = async (event) => {
    event.preventDefault();
    const mobile_reg = /^[6-9]{1}[0-9]{9}$/;
    const regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    const name_reg = /^[a-zA-Z ]*$/;

    if (
      inputs.name === "" ||
      inputs.name === undefined ||
      inputs.name.length <= 2
    ) {
      setname("Please enter your full name");
      errorRef.current.name = "Please enter your full name";
      isValid++;
    } else {
      if (!inputs.name.match(name_reg)) {
        setname("Please enter valid full name");
        errorRef.current.name = "Please enter valid full name";

        isValid++;
      } else {
        setname("");
      }
    }

    if (!inputs.branch && validpincode) {
      setbranch("Please select branch.");
      errorRef.current.branch = "Please select branch.";

      setNewMargin(true);
      isValid++;
    }

    if (!inputs.mobile) {
      setmobile("Please enter your mobile number.");
      errorRef.current.number = "Please enter your mobile number.";
      setNewMargin(true);
      isValid++;
    } else {
      if (!inputs.mobile.match(mobile_reg)) {
        setmobile("Please enter valid mobile number.");
        errorRef.current.number = "Please enter valid mobile number.";

        isValid++;
      } else {
        setmobile("");
      }
    }

    var otp_reg = /^[0-9]{6}$/;
    if (!inputs.otp) {
      setotp("Please enter valid otp.");
      errorRef.current.otp = "Please enter valid otp.";
      isValid++;
    } else {
      if (!inputs.otp.match(otp_reg)) {
        setotp("Please enter valid otp number.");
        errorRef.current.otp = "Please enter valid otp.";

        isValid++;
      } else {
        setotp("");
      }
    }

    if (!inputs.pan) {
      setpan("Please enter your pan number.");
      errorRef.current.pan = "Please enter your pan number.";
      setNewMargin(true);
      isValid++;
    } else {
      if (!inputs.pan.match(regpan)) {
        setpan("Please enter valid pan number.");
        errorRef.current.pan = "Please enter valid pan number.";
        isValid++;
      } else {
        setpan("");
      }
    }

    var pincode_reg = /^[1-9][0-9]{5}$/;
    if (!inputs.pincode) {
      setpincode("Please enter valid pincode.");
      errorRef.current.pincode = "Please enter valid pincode.";

      setNewMargin(true);
      isValid++;
    } else {
      if (!inputs.pincode.match(pincode_reg) || !validpincode) {
        setpincode("Please enter valid pincode.");
        errorRef.current.pincode = "Please enter valid pincode.";
        isValid++;
      } else {
        setpincode("");
      }
    }
    if (checked === false) {
      setcheckbox(
        "Kindly agree to our Terms & Conditions by clicking on the checkbox above."
      );
      errorRef.current.checkbox =
        "Kindly agree to our Terms & Conditions by clicking on the checkbox above..";

      setNewMargin(true);
      isValid++;
    } else {
      setcheckbox("");
    }

    if (isValid === 0) {
      // console.log("form input values", inputs);
      // notifyWarn("This may take upto 15 seconds. Please do not reload the page!")
      setApplyBtnDisable(true);

      // GET UTM DETAILS
      const utmParamsObj = queryString.parse(window.location.search);
      for (const [key, value] of Object.entries(utmParamsObj)) {
        inputs[key] = value;
      }
      // dob in YYYY-MM-DD format
      // let DateOfBirthValue = `${inputs.dob_year}-${inputs.dob_month.padStart(2, 0)}-${inputs.dob.padStart(2, 0)}`;

      // constants value
      // inputs.DateOfBirthValue = DateOfBirthValue

      // setInputs({
      //   ...inputs,
      //   token: token,
      //   solId: solId,
      //   isChecked: checked,
      //   FBPixelID: fbp,
      //   FBClickID: fbc,
      //   firstname: firstName,
      //   lastname: lastName,
      // });
      const { firstName, lastName } = getFirstNameLastName(inputs.name);

      const payloadInputs = {
        ...inputs,
        token: token,
        solId: solId,
        isChecked: checked,
        FBPixelID: fbp,
        FBClickID: fbc,
        firstname: firstName,
        lastname: lastName,
      };

      // console.log("final input values", inputs);
      let lsqInputs = getLsqLeadBody(payloadInputs);
      let payload = {
        mobile: payloadInputs.mobile,
        otp: payloadInputs.otp,
        formdata: lsqInputs,
      };
      let param = { productType: "BG" };
      console.log(payload, "payload for createLead");

      // Encrypt Payloads
      const encryptedPayload = await encryptBody(payload);
      console.log(encryptedPayload);
      const createLeadResp = await callLSQLapp(
        encryptedPayload,
        "CREATE",
        param
      );

      // ? IF Lead Created
      if (
        createLeadResp.data.message !== "Failure occured , please check logs"
      ) {
        let leadid = createLeadResp.data.message.Data.LeadApiCalls.Message.Id;
        handlePixelInit();
        if (inputs.mobile) {
          const formattedMobile = formatAndValidateE164(inputs.mobile);
          const hashedMobile = await hashValue(formattedMobile);
          setValuesInLocalStorange("userData", "", hashedMobile);
          console.log(localStorage.getItem("userData"), "userData");
        }

        console.log("navigate to thankyou");
        formSubmitEvent(inputs, true);
        navigate(`/thankyou?id=${leadid}`);
      } else {
        setApplyBtnDisable(false);
        console.log("lead not created.");
        formSubmissionFailEvent();
        console.log(window.adobeDataLayer || []);
        window.alert("Some error occured! Please try again after some time.");
        // window.location.reload();
      }
      // navigate("/thankyou");
    } else {
      isValid = 0;
      setNewMargin(true);
      submitErrorEvent(errorRef.current);
      return false;
    }
  };

  return (
    <article
      className={`banner_section position-relative  ${
        newMargin ? "m_update" : null
      }`}
    >
      <div className="banner_img">
        <picture>
          <source
            rel="preload"
            media="(max-width:428.5px)"
            srcSet="dist/img/ICICI_SavingAccount_Banner_mobile.webp"
            alt="ICICI Bank saving account banner"
            width={428}
            height={320}
            className="img-fluid"
          />
          <source
            rel="preload"
            media="(max-width:991.5px)"
            srcSet="dist/img/ICICI_SavingAccount_Banner_ipad.webp"
            alt="ICICI Bank saving account banner"
            width={768}
            height={574}
            className="img-fluid"
          />
          <img
            rel="preload"
            src="dist/img/ICICI_SavingAccount_Banner_desktop.webp"
            alt="Banner img"
            width={2560}
            height={893}
            className="img-fluid"
          />
        </picture>
      </div>
      <div className="saving_account_content"></div>
      <article className="digital_saving container-fluid">
        <div className="container">
          <p>
            With <b>iMobile</b> and <b>Internet Banking</b>, now manage your
            account{" "}
            <em>
              <b>Anytime, Anywhere</b>
            </em>
            .
          </p>
        </div>
      </article>
      <div className="container">
        <div className="row">
          <div className="col-lg-7 col-12">
            <div className="form_wrap" id="saving_account">
              <div className="form_heading">
                <h4>
                  {/* Savings Account Opening<br /> from Your Doorstep */}
                  Savings Account opening <br />
                  at your Doorstep
                </h4>
              </div>
              <form name="contactForm" method="post" onSubmit={handleSubmit}>
                <section className="personal-details">
                  {/* =========== first name and last name start =============*/}
                  <div className="col-12 my-2">
                    <div className="row">
                      <div className="col-12 my-2">
                        <input
                          type="text"
                          name="name"
                          placeholder="Full Name"
                          id="name"
                          value={
                            inputs.name
                              ? inputs.name.replace(/[^a-z ]/gi, "")
                              : ""
                          }
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onInput={(e) =>
                            (e.target.value = e.target.value.replace(
                              /[^a-zA-Z\s]/gi,
                              ""
                            ))
                          }
                          className={name !== "" ? "errBrdr" : ""}
                        />

                        <span
                          className="d-block pan_name px-0 mx-1"
                          style={{ fontWeight: "bold" }}
                        >
                          As per PAN
                        </span>
                        {name !== "" ? (
                          <span
                            style={{
                              fontSize: "12px",
                              fontFamily: "sans-serif",
                              fontStretch: "normal",
                              fontStyle: "12px",
                              fontWeight: 400,
                              lineHeight: "normal",
                              letterSpacing: "normal",
                              left: "15px",
                              bottom: 0,
                              color: "red",
                            }}
                          >
                            {name}
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  {/* =========== date of birth field end =========== */}
                  <div className="col-12 my-2">
                    <input
                      type={`${showPan ? "text" : "password"}`}
                      name="pan"
                      placeholder="PAN"
                      id="pan"
                      value={inputs.pan ? inputs.pan : ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 10))
                      }
                    />
                    <button
                      onClick={handlePanView}
                      aria-label="Eye"
                      className="show-pan"
                    >
                      <FaEye />
                    </button>
                  </div>
                  {pan !== "" ? (
                    <span
                      style={{
                        fontSize: "12px",
                        fontFamily: "sans-serif",
                        fontStretch: "normal",
                        fontStyle: "12px",
                        fontWeight: 400,
                        lineHeight: "normal",
                        letterSpacing: "normal",
                        left: "15px",
                        bottom: 0,
                        color: "red",
                      }}
                    >
                      {pan}
                    </span>
                  ) : null}
                  <div className="autocomplete">
                    <input
                      className=""
                      type="number"
                      min="0"
                      placeholder="Pincode"
                      id="pincode"
                      name="pincode"
                      value={
                        inputs.pincode > 0
                          ? inputs.pincode.replace(/^0+/, "")
                          : ""
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 6))
                      }
                      onChange={handleChangePIN}
                      onBlur={handleBlur}
                    />
                  </div>
                  {pincode !== "" ? (
                    <span
                      style={{
                        fontSize: "12px",
                        fontFamily: "sans-serif",
                        fontStretch: "normal",
                        fontStyle: "12px",
                        fontWeight: 400,
                        lineHeight: "normal",
                        letterSpacing: "normal",
                        left: "15px",
                        bottom: 0,
                        color: "red",
                      }}
                    >
                      {pincode}
                    </span>
                  ) : null}

                  <div
                    className="col-12 my-2"
                    style={{
                      display:
                        inputs["pincode"]?.length === 6 &&
                        pincode === "" &&
                        validpincode
                          ? "block"
                          : "none",
                    }}
                  >
                    <select
                      className="col-12 my-2"
                      name="branch"
                      id="branch"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      {options.map((option) => (
                        <option
                          key={option.SOL_ID}
                          value={option.Branch_Name}
                          solid={option.SOL_ID}
                        >
                          {option.Branch_Name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {branch !== "" ? (
                    <span
                      style={{
                        fontSize: "12px",
                        fontFamily: "sans-serif",
                        fontStretch: "normal",
                        fontStyle: "12px",
                        fontWeight: 400,
                        lineHeight: "normal",
                        letterSpacing: "normal",
                        left: "15px",
                        bottom: 0,
                        color: "red",
                      }}
                    >
                      {branch}
                    </span>
                  ) : null}
                  <div className="my-2">
                    <span className="position-relative ">
                      <span className=" number-span ">+91 </span>
                      <input
                        readOnly={disableBtn}
                        type="number"
                        name="mobile"
                        placeholder="Mobile number"
                        value={
                          inputs.mobile > 0
                            ? inputs.mobile.replace(/^[0-5]+/, "")
                            : ""
                        }
                        pattern="\d{10}"
                        onInput={(e) =>
                          (e.target.value = e.target.value.slice(0, 10))
                        }
                        onBlur={handleBlur}
                        onChange={handleChange}
                        id="mobile_number"
                        style={{ textAlign: "left" }}
                        className={mobile !== "" ? "errBrdr" : "errBrdr"}
                        onWheel={(e) => e.target.blur()}
                      />

                      {!otpsent && (
                        <button
                          type="button"
                          className="btn"
                          id="resendBtn"
                          onClick={() => sendOTPText(inputs.mobile, "send")}
                          style={{ display: resendBtnDisplay }}
                          disabled={otpDisabled}
                        >
                          Send OTP
                        </button>
                      )}

                      {inputs.mobile?.length === 10 && otpsent && timer <= 0 ? (
                        <button
                          type="button"
                          className="btn"
                          id="resendBtn"
                          onClick={() => sendOTPText(inputs.mobile, "resend")}
                          style={{ display: resendBtnDisplay }}
                          disabled={otpDisabled}
                        >
                          {otpBtnText}
                        </button>
                      ) : (
                        <span
                          className="Timer"
                          id="timer"
                          style={{ display: timerDisplay }}
                        >
                          {" "}
                          00:
                          {timer.toString().length < 2
                            ? timer.toString().padStart(2, "00")
                            : timer}
                        </span>
                      )}
                    </span>
                  </div>
                  {mobile !== "" ? (
                    <span
                      style={{
                        fontSize: "12px",
                        fontFamily: "sans-serif",
                        fontStretch: "normal",
                        fontStyle: "12px",
                        fontWeight: 400,
                        lineHeight: "normal",
                        letterSpacing: "normal",
                        left: "15px",
                        bottom: 0,
                        color: "red",
                      }}
                    >
                      {mobile}
                    </span>
                  ) : null}
                  {/* Css Class added for full length blank otp field  */}
                  <div
                    className={
                      otpstatus === 0
                        ? " align-items-center w-100 mt-1"
                        : "d-flex align-items-center w-75 mt-1"
                    }
                  >
                    <input
                      autoComplete="one-time-code"
                      value={inputs["otp"] ? inputs["otp"] : ""}
                      readOnly={disableBtn}
                      type="number"
                      min="0"
                      name="otp"
                      pattern="\d{6}"
                      placeholder="OTP"
                      id="otp"
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 6))
                      }
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {/* =========== timer and resend button start =============*/}
                    {otpstatus === 2 ? (
                      <div className="timer_wrapper text-center ms-1">
                        <span id="timer">00:00</span>
                      </div>
                    ) : (
                      ""
                    )}
                    {otpstatus === 1 ? (
                      <div className="resend_btn ms-1">
                        <button>Resend</button>
                      </div>
                    ) : (
                      ""
                    )}
                    {/* =========== timer and resend button end =============*/}
                  </div>
                  {otp !== "" ? (
                    <span
                      style={{
                        fontSize: "12px",
                        fontFamily: "sans-serif",
                        fontStretch: "normal",
                        fontStyle: "12px",
                        fontWeight: 400,
                        lineHeight: "normal",
                        letterSpacing: "normal",
                        left: "15px",
                        bottom: 0,
                        color: "red",
                      }}
                    >
                      {otp}
                    </span>
                  ) : null}
                  <div className="checkbox row">
                    <div className="col-1 check-input">
                      <input
                        type="checkbox"
                        name="checkbox"
                        onChange={handleChange}
                        defaultChecked={checked}
                        onClick={() => {
                          setChecked(!checked);
                          eventWithFormInfo(
                            "terms & conditions",
                            "checkbox",
                            "form",
                            "",
                            inputs
                          );
                        }}
                        id="checkbox"
                      />
                    </div>
                    <div className="col-11 p-0 ">
                      <label htmlFor="checkbox">
                        I authorise ICICI Bank and its representatives to
                        contact me through phone, email, SMS and WhatsApp. I
                        also agree to ICICI Bank’s{" "}
                        <a
                          href="https://www.icicibank.com/content/dam/icicibank/india/managed-assets/docs/terms-condition/tnc-savings-account.pdf"
                          onClick={() => {
                            eventWithFormInfo(
                              "terms & conditions",
                              "link",
                              "form"
                            );
                          }}
                          onContextMenu={handleRightCLickTC}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {" "}
                          Terms & Conditions
                        </a>
                        .
                      </label>
                    </div>
                    {checkbox !== "" ? (
                      <span
                        className="agree_span"
                        style={{
                          fontSize: "12px",
                          fontFamily: "sans-serif",
                          fontStretch: "normal",
                          fontStyle: "12px",
                          fontWeight: 400,
                          lineHeight: "normal",
                          letterSpacing: "normal",
                          position: "relative",
                          color: "red",
                        }}
                      >
                        {checkbox}
                      </span>
                    ) : null}
                  </div>
                  <div className="applynow">
                    <button
                      disabled={disableApplyBtn}
                      type="submit"
                      style={{
                        backgroundColor: disableApplyBtn ? "grey" : "",
                      }}
                    >
                      {disableApplyBtn ? "Submitting..." : "Apply Now"}
                    </button>
                  </div>
                </section>
              </form>
              <ToastContainer />
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}

export default Form;
